import apolloClient from '../../utils/apollo-client';
import { employeeSignComplete as mutation } from '../graphql/docusign';
import Mock from '@/api/approvals/mock';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function employeeSignComplete(payLoad) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.employeeSignComplete;
  }

  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: {
        payLoad
      }
    })
  );

  return response.data.employeeSignComplete;
}
